module.exports = __webpack_public_path__ + "img/img23.8cf74fdd.png";